export default __webpack_public_path__ + "static/media/YAS0750.34I-35138_-21046_0.9062f720.jpg";